import { AppProps } from '../App'
import Footer from './Footer'
import Navbar from './Navbar'
import SidebarContent from './SidebarContent'

interface Props extends AppProps {
  children?: React.ReactNode
  background?: string
  padding?: number
  withoutSidebar?: boolean
  styles?: React.CSSProperties
}

const MainWrapper = (props: Props) => {
  return (
    <>
      <Navbar {...props} />
      <div className='flex-1 flex overflow-hidden'>
        {!props.withoutSidebar && <aside className='app-sidebar hidden md:flex flex-col p-2 gap-1 overflow-auto h-full w-56 border-r'><SidebarContent {...props} /></aside>}
        <main className={`flex-1 flex flex-col overflow-auto p-4 md:px-8 relative`} style={{ background: props.background || '', ...(props.padding !== undefined ? { padding: props.padding } : {}), ...(props.styles || {}) }}>
          {props.children}
        </main>
      </div>
      {/* <Footer /> */}
    </>
  )
}

export default MainWrapper